import { render, staticRenderFns } from "./RamsExternalView.vue?vue&type=template&id=6288e05c&"
import script from "./RamsExternalView.vue?vue&type=script&lang=js&"
export * from "./RamsExternalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports